export default __webpack_public_path__ + "static/media/short-logo.02ce7e4b.png";